import script from "./UserAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAuth.vue?vue&type=script&setup=true&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=49412597&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49412597"]])

export default __exports__